import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import { Button } from "primereact/button";
import AdminOnly from "~/components/AdminOnly";

import "../officers-form.scss";
import OfficerAttachmentTable from "./OfficerAttachmentTable";
import useOfficerAttachment from "./useOfficerAttachment";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";
import Notification from "~/components/entities/notification/Notification";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import { useSelector } from "react-redux";
import { mergeCategories } from "~/Pages/Requests/components/new-request-modal/utils";
import BlobFilter from "~/components/BlobFilter";
import FilterChip from "~/components/FilterChip";
import useAttachmentFilter from "~/hooks/useAttachmentFilter";

const OfficerAttacments = ({ type }) => {
  const { id } = useParams();

  const {
    filesData,
    loading,
    page,
    rows,
    first,
    totalRecords,
    onPageChange,
    isDataAvailable,
    setOpenDialog,
    fileSupported,
    openDialog,
    uploadFileHandler,
    entityData,
    isFileUploaded,
    successMessage,
    setSuccessMessage,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    getType,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    handleConfirmDelete,
    isAttachmentLoader,
    handleRestoreAttachment,
    temporaryMessage,
    restoreMessage,
    setRstoreMessage,
    setTemporaryMessage,
    selectedItems,
    filterData,
    setFilterData,
    removeFnRef,
    handleRemoveFilter,
    handleFilterChange,
    filterLoading,
    onSortOrderChange,
    onFilterApply,
    allData,
    filterPageChange,
    currentPage,
    fetchOfficerAttachments,
  } = useOfficerAttachment();
  const entity = useSelector((state) => state.globalEntities.entity_detail);
  const { role } = useSelector((state) => state.login);
  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "Address Updated",
      delete: "File(s) Deleted",
    };
  };

  return (
    <Card className="gen-card officer__attachments">
      <div className="flex justify-content-between mb-5">
        <div>
          <p className="officer__attachments--heading">Files & Attachments</p>
          <p className="officer__attachments--description">
            Files & Attachments for this{" "}
            {type === "officer" ? "officer" : "attorney"}.
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <AdminOnly>
            <Button
              className="edit-button"
              onClick={() => setAuditSidebarVisible(true)}
            >
              View History
              <span className="pi pi-history mb-1 ml-2" />
            </Button>
          </AdminOnly>
          <div>
            <BlobFilter
              onApply={({ value, group }) => {
                setFilterData(value);
              }}
              onRemove={(fn) => (removeFnRef.current = fn)}
              onFilterChange={({ value, grouped }) => {
                handleFilterChange(grouped);
              }}
              showEntity={false}
              showServiceLine={false}
              showYears={false}
              serviceLine={"Entities +"}
              disabled={!isDataAvailable}
            />
          </div>
          <AdminOnly>
            <Button
              className="btn-primary font-semibold"
              onClick={() => setOpenDialog(true)}
            >
              Upload File
              <span className="pi pi-upload mb-1 ml-2" />
            </Button>
          </AdminOnly>
        </div>
      </div>
      <FilterChip
        filterData={filterData}
        removeFilter={(id) => {
          handleRemoveFilter(id);
        }}
      />
      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      <div className="mt-4">
        <OfficerAttachmentTable
          files={selectedItems.length ? allData : filesData}
          loading={selectedItems.length ? filterLoading : loading}
          page={selectedItems.length ? currentPage : page}
          rows={rows}
          totalRecords={
            selectedItems.length ? allData.length : filesData?.length
          }
          onPageChange={
            selectedItems.length
              ? (e) => {
                  filterPageChange(e.page + 1);
                }
              : onPageChange
          }
          isDataAvailable={
            selectedItems.length ? allData.length : isDataAvailable
          }
          setOpenDialog={setOpenDialog}
          type={type}
          first={selectedItems.length ? page - 1 : first}
          handleAttachmentDelete={handleDeleteDocument}
          onSortOrderChange={
            selectedItems?.length ? onSortOrderChange : undefined
          }
          isFilterApplied={selectedItems.length}
          onRefetch={
            selectedItems?.length ? onFilterApply : fetchOfficerAttachments
          }
        />
      </div>
      <FileUploadModal
        entitydata={entityData?.entityData}
        showModal={openDialog}
        fileSupported={fileSupported}
        hideUploadModal={() => setOpenDialog(false)}
        setUploadedFile={uploadFileHandler}
        getService={getType}
        placeholder={"Choose a file to upload"}
        loading={!isFileUploaded}
        close={false}
        officerdata={entityData}
        relatedType={"OFFICER"}
        categories={mergeCategories(["Entities +"], role)}
      />

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Attachments"
          endpoint={API_ROUTES.FETCH_ATTACHMENT_AUDIT}
          id={id}
          objectType="OFFICER"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </Card>
  );
};

export default OfficerAttacments;
